import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import TitleTagsComponent from "../Misc/TitleTags/TitleTagsComponent";
import { useDispatch } from "react-redux";
import { SessionKeys } from "../../../utils/AppUtils";

import CONFIG from "../../../utils/config";
import API_LIST from "../../../utils/apiList";
import { postLikeDisLikeProduct } from "../../../redux/discuss/actions";
import { getShowLoader } from "../../../redux/home/actions";
import { addToWishList } from "../../../redux/product/actions";

const PopularCourseCardB2C = (props) => {
  const {
    id,
    dbId,
    is_like,
    is_bookmark,
    is_wishlist,
    productType,
    productOrigin,
    btnAction,
    bannerAction,
    title,
    duration,
    thumbnail,
    tagsArray,
    isLoading,
    priceInfo
  } = props;

  console.log("isLoading", isLoading);

  const dispatch = useDispatch();

  const [isLikeClicked, setIsLikeClicked] = useState(false);
  const [isBookMarkClicked, setIsBookMarkClicked] = useState(false);
  useEffect(() => {
    setIsLikeClicked(is_like);
  }, [is_like]);

  useEffect(() => {
    setIsBookMarkClicked(is_bookmark);
  }, [is_bookmark]);

  useEffect(() => {
    console.log("islike--after", typeof is_like, typeof isLikeClicked);
  }, [isLikeClicked]);

  const postLikeDisLike = () => {
    setIsLikeClicked(!isLikeClicked);
    dispatch(
      postLikeDisLikeProduct({
        URL: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.LIKE_DISLIKE_PRODUCT}`,
        method: "post",
        isJSON: true,
        payload: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          entity_id: dbId,
          entity_type: productType,
          origin: productOrigin,
          like: !is_like,
        },
      })
    );
  };
  const postBookmark = () => {
    setIsBookMarkClicked(!isBookMarkClicked);
  };

  const saveToLearnList = () => {
    dispatch(getShowLoader("true"));
    dispatch(
      addToWishList({
        module: "addToWishList",
        postData: {
          pid: id,
          uemail: localStorage.getItem(SessionKeys.EMAIL_SESSION),
        },
      })
    );
  };

  return (
    <>
      <div className="course-listing">
        <ul className="course-box">
          <li className="course-list-item">
            <div className="d-flex coure-body-box">
              {isLoading ? (
                <ShimmerScreen
                  case="rect"
                  width="11.25rem"
                  height="6.32813rem"
                />
              ) : (
                <div className="img-list-box">
                  <div className="video-wrap-home position-relative">
                    <img src={thumbnail} alt={title} onClick={bannerAction} />
                    <button className="playbtn" onClick={bannerAction}></button>
                    <span className="duration-bar">{duration}</span>
                  </div>
                </div>
              )}

              <div className="course-list-discription">
                {isLoading ? (
                  <ShimmerScreen case="rect" width="15rem" height="1.25rem" />
                ) : (
                  <div className="course-list-title cursor-pointer" onClick={btnAction}>
                    {title}
                  </div>
                )}
                {/* <ul className="cardlist-row">
                <li>
                  <span>Xsel</span>
                </li>
                <li>
                  <span>Video</span>
                </li>
                <li>
                  <span>26 Views</span>
                </li>
                <li>
                  <span>45 Mins</span>
                </li>
              </ul> */}
                <TitleTagsComponent
                  tagsArray={tagsArray}
                  isLoading={isLoading}
                />
              </div>
            </div>
            {isLoading ? (
              <ShimmerScreen case="rect" width="0.4rem" height="1.5rem" />
            ) : (
              <Dropdown className="customdropdown-btn">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="20"
                    viewBox="0 0 6 20"
                    fill="none"
                  >
                    <path
                      d="M3.18018 19.1706C2.52705 19.1706 1.96794 18.9437 1.50283 18.49C1.03773 18.0362 0.805176 17.4907 0.805176 16.8535C0.805176 16.2163 1.03773 15.6709 1.50283 15.2171C1.96794 14.7634 2.52705 14.5365 3.18018 14.5365C3.8333 14.5365 4.39242 14.7634 4.85752 15.2171C5.32262 15.6709 5.55518 16.2163 5.55518 16.8535C5.55518 17.4907 5.32262 18.0362 4.85752 18.49C4.39242 18.9437 3.8333 19.1706 3.18018 19.1706ZM3.18018 12.2194C2.52705 12.2194 1.96794 11.9925 1.50283 11.5388C1.03773 11.085 0.805176 10.5395 0.805176 9.90233C0.805176 9.26513 1.03773 8.71965 1.50283 8.26589C1.96794 7.81213 2.52705 7.58525 3.18018 7.58525C3.8333 7.58525 4.39242 7.81213 4.85752 8.26589C5.32262 8.71965 5.55518 9.26513 5.55518 9.90233C5.55518 10.5395 5.32262 11.085 4.85752 11.5388C4.39242 11.9925 3.8333 12.2194 3.18018 12.2194ZM3.18018 5.26818C2.52705 5.26818 1.96794 5.0413 1.50283 4.58754C1.03773 4.13378 0.805176 3.5883 0.805176 2.95111C0.805176 2.31391 1.03773 1.76843 1.50283 1.31467C1.96794 0.860913 2.52705 0.634033 3.18018 0.634033C3.8333 0.634033 4.39242 0.860913 4.85752 1.31467C5.32262 1.76843 5.55518 2.31391 5.55518 2.95111C5.55518 3.5883 5.32262 4.13378 4.85752 4.58754C4.39242 5.0413 3.8333 5.26818 3.18018 5.26818Z"
                      fill="#292D32"
                    />
                  </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div className="list-drop" onClick={() => postLikeDisLike()}>
                    {isLikeClicked ? (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="#ff2600"
                            d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                          />
                        </svg>
                      </>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="black"
                      >
                        <path
                          d="M12 21L10.55 19.7C8.86667 18.1833 7.475 16.875 6.375 15.775C5.275 14.675 4.4 13.6875 3.75 12.8125C3.1 11.9375 2.64583 11.1333 2.3875 10.4C2.12917 9.66666 2 8.91666 2 8.14999C2 6.58333 2.525 5.27499 3.575 4.22499C4.625 3.17499 5.93333 2.64999 7.5 2.64999C8.36667 2.64999 9.19167 2.83333 9.975 3.19999C10.7583 3.56666 11.4333 4.08333 12 4.74999C12.5667 4.08333 13.2417 3.56666 14.025 3.19999C14.8083 2.83333 15.6333 2.64999 16.5 2.64999C18.0667 2.64999 19.375 3.17499 20.425 4.22499C21.475 5.27499 22 6.58333 22 8.14999C22 8.91666 21.8708 9.66666 21.6125 10.4C21.3542 11.1333 20.9 11.9375 20.25 12.8125C19.6 13.6875 18.725 14.675 17.625 15.775C16.525 16.875 15.1333 18.1833 13.45 19.7L12 21ZM12 18.3C13.6 16.8667 14.9167 15.6375 15.95 14.6125C16.9833 13.5875 17.8 12.6958 18.4 11.9375C19 11.1792 19.4167 10.5042 19.65 9.91249C19.8833 9.32083 20 8.73333 20 8.14999C20 7.14999 19.6667 6.31666 19 5.64999C18.3333 4.98333 17.5 4.64999 16.5 4.64999C15.7167 4.64999 14.9917 4.87083 14.325 5.31249C13.6583 5.75416 13.2 6.31666 12.95 6.99999H11.05C10.8 6.31666 10.3417 5.75416 9.675 5.31249C9.00833 4.87083 8.28333 4.64999 7.5 4.64999C6.5 4.64999 5.66667 4.98333 5 5.64999C4.33333 6.31666 4 7.14999 4 8.14999C4 8.73333 4.11667 9.32083 4.35 9.91249C4.58333 10.5042 5 11.1792 5.6 11.9375C6.2 12.6958 7.01667 13.5875 8.05 14.6125C9.08333 15.6375 10.4 16.8667 12 18.3Z"
                          fill="black"
                        />
                      </svg>
                    )}
                    Like
                  </div>
                  {false && (
                    <>
                      <div className="list-drop">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7625 15.025 18.6375C15.0417 18.5125 15.0667 18.4 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.6458 7.1 14.7875C6.75 14.9292 6.38333 15 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.07083 7.1 9.2125C7.45 9.35417 7.76667 9.55 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.4875 15.025 5.3625C15.0083 5.2375 15 5.11667 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92917 16.9 7.7875C16.55 7.64583 16.2333 7.45 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5125 8.975 11.6375C8.99167 11.7625 9 11.8833 9 12C9 12.1167 8.99167 12.2375 8.975 12.3625C8.95833 12.4875 8.93333 12.6 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3542 16.9 16.2125C17.25 16.0708 17.6167 16 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22ZM18 6C18.2833 6 18.5208 5.90417 18.7125 5.7125C18.9042 5.52083 19 5.28333 19 5C19 4.71667 18.9042 4.47917 18.7125 4.2875C18.5208 4.09583 18.2833 4 18 4C17.7167 4 17.4792 4.09583 17.2875 4.2875C17.0958 4.47917 17 4.71667 17 5C17 5.28333 17.0958 5.52083 17.2875 5.7125C17.4792 5.90417 17.7167 6 18 6ZM6 13C6.28333 13 6.52083 12.9042 6.7125 12.7125C6.90417 12.5208 7 12.2833 7 12C7 11.7167 6.90417 11.4792 6.7125 11.2875C6.52083 11.0958 6.28333 11 6 11C5.71667 11 5.47917 11.0958 5.2875 11.2875C5.09583 11.4792 5 11.7167 5 12C5 12.2833 5.09583 12.5208 5.2875 12.7125C5.47917 12.9042 5.71667 13 6 13ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19C19 18.7167 18.9042 18.4792 18.7125 18.2875C18.5208 18.0958 18.2833 18 18 18C17.7167 18 17.4792 18.0958 17.2875 18.2875C17.0958 18.4792 17 18.7167 17 19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20Z"
                            fill="black"
                          />
                        </svg>{" "}
                        Share
                      </div>
                      <div className="list-drop" onClick={() => postBookmark()}>
                        {isBookMarkClicked ? (
                          <svg
                            width="24"
                            height="26"
                            viewBox="-6 -2 22 22"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              id="Page-1"
                              stroke="none"
                              strokeWidth="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Dribbble-Light-Preview"
                                transform="translate(-305.000000, -2679.000000)"
                                strokeWidth="2"
                                stroke="#ff9800"
                                fill="#ff9800"
                              >
                                <g
                                  id="icons"
                                  transform="translate(56.000000, 160.000000)"
                                >
                                  <polygon
                                    id="bookmark_fill-[#1226]"
                                    points="259 2519 259 2539 254 2534 249 2539 249 2519"
                                  ></polygon>
                                </g>
                              </g>
                            </g>
                          </svg>
                        ) : (
                          <svg
                            width="24"
                            height="26"
                            viewBox="-6 -2 22 22"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              id="Page-1"
                              stroke="none"
                              strokeWidth="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Dribbble-Light-Preview"
                                transform="translate(-305.000000, -2679.000000)"
                                strokeWidth="2"
                                stroke="black"
                                fill="none"
                              >
                                <g
                                  id="icons"
                                  transform="translate(56.000000, 160.000000)"
                                >
                                  <polygon
                                    id="bookmark_fill-[#1226]"
                                    points="259 2519 259 2539 254 2534 249 2539 249 2519"
                                  ></polygon>
                                </g>
                              </g>
                            </g>
                          </svg>
                        )}
                        Bookmark
                      </div>
                    </>
                  )}
                  {!priceInfo?.isPurchased && !priceInfo?.isFree && (
                    <div
                      className="list-drop"
                      onClick={() => (is_wishlist ? "" : saveToLearnList())}
                    >
                      {is_wishlist ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 18H20V15.325H9V18ZM4 8.675H7V6H4V8.675ZM4 13.35H7V10.675H4V13.35ZM4 18H7V15.325H4V18ZM9 13.35H20V10.675H9V13.35ZM9 8.675H20V6H9V8.675ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                            fill="#0fb41c"
                          ></path>
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 18H20V15.325H9V18ZM4 8.675H7V6H4V8.675ZM4 13.35H7V10.675H4V13.35ZM4 18H7V15.325H4V18ZM9 13.35H20V10.675H9V13.35ZM9 8.675H20V6H9V8.675ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                            fill="black"
                          />
                        </svg>
                      )}{" "}
                      Save to Wishlist
                    </div>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </li>
        </ul>
      </div>
    </>
  );
};

export default PopularCourseCardB2C;
